import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export default function Terms() {
  return (
    <div className="min-h-screen bg-stone-50">
      <header className="bg-white border-b border-stone-200 px-4 md:px-8 py-4">
        <div className="max-w-3xl mx-auto flex items-center justify-between">
          <Link to="/" className="inline-flex items-center gap-1 text-stone-600 hover:text-stone-900 text-sm">
            <ChevronLeft size={16} /> ホームへ戻る
          </Link>
          <span className="text-xs text-stone-400">最終更新: 2026年5月18日</span>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 md:px-8 py-10">
        <h1 className="font-display text-3xl md:text-4xl font-black text-stone-900 mb-2">利用規約・免責事項</h1>
        <p className="text-stone-600 text-sm mb-8">
          やさまるタイム(以下「本サービス」)をご利用いただくにあたり、以下の規約および免責事項にご同意いただく必要があります。
        </p>

        <Section title="1. サービス内容">
          <p>本サービスは、中小企業向けの勤怠打刻・集計を提供するWebアプリケーションです。提供機能は予告なく変更・追加・終了する場合があります。</p>
        </Section>

        <Section title="2. 利用契約">
          <p>サインアップ手続きの完了をもって、当社とお客様(以下「契約者」)との間に利用契約が成立するものとします。契約者は本規約に同意の上、本サービスをご利用ください。</p>
        </Section>

        <Section title="3. 料金">
          <ul className="list-disc ml-6 space-y-1">
            <li>通常プラン: 月額 1,500円(税抜) ※30名まで一律</li>
            <li>無料お試し期間: 初回登録から14日間</li>
            <li>追加オプション:
              <ul className="list-disc ml-6 mt-1">
                <li>複数拠点・部署分け: +800円/月(税抜)</li>
                <li>カスタムCSV出力: 15,000円(税抜、買い切り)</li>
              </ul>
            </li>
            <li>料金は予告なく変更する場合があります。変更時は事前に通知します。</li>
          </ul>
        </Section>

        <Section title="4. お支払い">
          <p>お支払いは、Stripe社の決済サービスを通じて、登録いただいたクレジットカードから自動引き落としにて行います。試用期間終了後、自動的に課金が開始されます。途中解約はいつでも可能です(日割り返金は行いません)。</p>
        </Section>

        <Section title="5. 禁止事項">
          <p>契約者は、本サービスの利用にあたり以下の行為をしてはなりません。</p>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li>法令または公序良俗に違反する行為</li>
            <li>当社または第三者の権利・利益を侵害する行為</li>
            <li>不正アクセス、リバースエンジニアリング、改ざんなど技術的攻撃行為</li>
            <li>過度な負荷をかける行為(自動化された大量リクエストなど)</li>
            <li>本サービスを再販・転売する行為</li>
            <li>その他、当社が不適切と判断する行為</li>
          </ul>
        </Section>

        <Section title="6. 利用停止・契約解除">
          <p>契約者が本規約に違反した場合、または料金未払いが発生した場合、当社は事前通知なくサービスの一部または全部の利用を停止することがあります。重大な違反の場合は、当社の判断で契約を解除することができます。</p>
        </Section>

        <Section title="7. 免責事項">
          <ul className="list-disc ml-6 space-y-1">
            <li>本サービスは「現状有姿」で提供されます。当社は、サービスの正確性、完全性、有用性、特定目的への適合性について明示・黙示を問わず一切保証しません。</li>
            <li>本サービスを利用したことに起因する直接・間接の損害について、当社の故意または重過失による場合を除き、当社は責任を負いません。</li>
            <li>システム障害、メンテナンス、回線・通信不良、第三者サービス(Stripe、ホスティング等)の障害により本サービスの全部または一部が利用できなくなった場合の損害について、当社は責任を負いません。</li>
            <li>勤怠記録の最終確認・労働基準法の遵守については、契約者の責任において行うものとし、当社は集計値の正確性を保証するものではありません。</li>
            <li>当社の責任が認められる場合でも、損害賠償額は、契約者が当社に過去12か月間に支払った利用料金の合計額を上限とします。</li>
          </ul>
        </Section>

        <Section title="8. サービスの変更・終了">
          <p>当社は、30日前までの通知をもって、本サービスの全部または一部を変更・終了することができます。サービス終了時には、お客様のデータをエクスポート可能な形式でご提供します。</p>
        </Section>

        <Section title="9. データのバックアップと保存義務">
          <ul className="list-disc ml-6 space-y-1">
            <li>労働基準法第109条により、使用者(雇用主)は賃金台帳・出勤簿等を一定期間保存する義務があります。<strong>この保存義務は雇用主である契約者に課されるものであり、当社の義務ではありません。</strong></li>
            <li>契約者は、勤怠データを定期的に管理画面の<strong>CSV出力機能</strong>でダウンロードし、自社の責任において保管してください。</li>
            <li>契約終了・解約後は当社が保有する勤怠データを削除する場合があります。契約終了前に必要なデータをCSV出力でバックアップいただくことを強く推奨します。</li>
            <li>システム障害、データ消失等により当社が保有するデータが失われた場合でも、契約者がCSVバックアップを取得していなかったことに起因する損害について、当社は責任を負いません。</li>
          </ul>
        </Section>

        <Section title="10. 個人情報の取扱い">
          <p>本サービスにおける個人情報の取扱いについては、<Link to="/privacy" className="text-emerald-600 hover:underline">プライバシーポリシー</Link>に定めるところによります。</p>
        </Section>

        <Section title="11. 知的財産権">
          <p>本サービスに関する著作権、商標権その他の知的財産権は、当社または正当な権利者に帰属します。契約者は、本サービスの利用に必要な範囲を超えてこれらを利用してはなりません。</p>
        </Section>

        <Section title="12. 準拠法・管轄">
          <p>本規約は日本国法に準拠し、本サービスに関する紛争は、当社所在地を管轄する裁判所を第一審の専属合意管轄裁判所とします。</p>
        </Section>

        <Section title="13. 規約の変更">
          <p>当社は、必要に応じて本規約を変更することがあります。変更後の規約は、本サービス内に掲示した時点で効力を生じるものとし、変更後も本サービスを継続利用された場合、変更に同意したものとみなします。</p>
        </Section>

        <div className="mt-10 text-sm text-stone-500">
          関連: <Link to="/privacy" className="text-emerald-600 hover:underline">プライバシーポリシー</Link>
        </div>
      </main>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section className="mb-7">
      <h2 className="font-display font-black text-lg text-stone-900 mb-2">{title}</h2>
      <div className="text-stone-700 text-sm leading-relaxed">{children}</div>
    </section>
  );
}
